export default [
  { id: 0, name: 'Black', value: '#111111' },
  { id: 1, name: 'Navy', value: '#001f3f' },
  { id: 2, name: 'Blue', value: '#0074D9' },
  { id: 3, name: 'Aqua', value: '#7FDBFF' },
  { id: 4, name: 'Teal', value: '#39CCCC' },
  { id: 5, name: 'Olive', value: '#3D9970' },
  { id: 6, name: 'Green', value: '#2ECC40' },
  { id: 7, name: 'Lime', value: '#01FF70' },
  { id: 8, name: 'Yellow', value: '#FFDC00' },
  { id: 9, name: 'Orange', value: '#FF851B' },
  { id: 10, name: 'Red', value: '#FF4136' },
  { id: 11, name: 'Maroon', value: '#85144b' },
  { id: 12, name: 'Fuchsia', value: '#F012BE' },
  { id: 13, name: 'Purple', value: '#B10DC9' },
  { id: 14, name: 'Gray', value: '#AAAAAA' },
  { id: 15, name: 'Silver', value: '#DDDDDD' },
  { id: 16, name: 'White', value: '#FFFFFF' },
];
